import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import ApartmentIcon from "@material-ui/icons/Apartment";
import AssignmentIndIcon from "@material-ui/icons/AssignmentInd";
import DescriptionIcon from "@material-ui/icons/Description";
import GroupIcon from "@material-ui/icons/Group";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import CompanyReport from "./companyReport";
import EmployeeReport from "./employeeReport";
import DocumentCompanyReport from "./documentsCompanyReport";
import DocumentEmployeeReport from "./documentsEmployeeReport";
import IntegrationReport from "./integrationReport";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-force-tabpanel-${index}`}
      aria-labelledby={`scrollable-force-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};

function a11yProps(index) {
  return {
    id: `scrollable-force-tab-${index}`,
    "aria-controls": `scrollable-force-tabpanel-${index}`
  };
}

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper
  }
}));

export default function ScrollableTabsButtonForce() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <div className="row page-titles">
        <div className="col-md-5 col-8 align-self-center">
          <h3 className="text-themecolor">Relatórios</h3>
        </div>
      </div>
      <div className={classes.root}>
        <AppBar position="static" color="default">
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="on"
            indicatorColor="primary"
            textColor="primary"
            aria-label="scrollable force tabs example"
          >
            <Tab label="Empresas" icon={<ApartmentIcon />} {...a11yProps(0)} />
            <Tab
              label="Colaboradores"
              icon={<AssignmentIndIcon />}
              {...a11yProps(1)}
            />
            <Tab
              label="Docs. empresa"
              icon={<DescriptionIcon />}
              {...a11yProps(2)}
            />
            <Tab
              label="Docs. colaborador"
              icon={<DescriptionIcon />}
              {...a11yProps(3)}
            />
            <Tab label="Integrações" icon={<GroupIcon />} {...a11yProps(3)} />
          </Tabs>
        </AppBar>
        <TabPanel value={value} index={0}>
          <CompanyReport />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <EmployeeReport />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <DocumentCompanyReport />
        </TabPanel>
        <TabPanel value={value} index={3}>
              <DocumentEmployeeReport />
        </TabPanel>
        <TabPanel value={value} index={4}>
          <IntegrationReport />
        </TabPanel>
      </div>
    </>
  );
}
